<template>
  <div class="ChangePassword">
    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getYouJiaUrlApi } from "@api/user";
import { VUE_APP_API_URL } from "@utils";

export default {
  name: "MyEquity",
  components: {},
  props: {},
  data: function() {
    return {
      captcha: "",
      phone: "", //手机号
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.getUrl();
  },
  methods: {
    getUrl() {
      getYouJiaUrlApi()
        .then(res => {
					console.log(res);
					if (res.data.edit) {
						this.$dialog.error(res.msg);
						this.$router.push({ path: "/user/data", query: {goUrl : 1}});
					} else {
						window.location.href = res.data.url;
					}
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
  }
};
</script>
<style scoped>
.codeVal {
  width: 1.5rem;
  height: 0.5rem;
}
.codeVal img {
  width: 100%;
  height: 100%;
}
</style>
